// extracted by mini-css-extract-plugin
export default {"ClientDetail":"ClientDetail_ClientDetail__+Z5sn","tableResponsive":"ClientDetail_tableResponsive__+M8Rb"};